import React, { Component } from 'react';

import Regulations from '../../regulations';
import decl from '../../helpers/declension';
import QrPCView from './qr-pc-view';
import QrMobileView from './qr-mobile-view';
import { setCookie, monthTimeout } from '../../../../helpers/cookie';

export default class SbpPay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sbpResponse: null
        }
    }
    
    componentDidMount() {
        const data = {
            'order-id': this.props.orderId,
            'pay-method': 'sbp',
        };

        const headers = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        };

        if (process.env.NODE_ENV !== 'dev') headers.credentials = 'include';

        this.setState({
            loading: true,
        });

        const route = '/local/php_interface/api/v2/payment/pay/';

        // try to buy a ticket
        fetch(route, headers)
            .then(response => response.json())
            .then(json => {
                if (json.status === 'success') {
                    if (json.data.bonus_order) {
                        this.setState({
                            loading: false,
                        });
                    } else {
                        this.setState({sbpResponse : json.data });

                        setCookie('UNPAID_ORDER', 'TRUE');
                        setCookie('PAYMENT_LINK', json.data.redirect_url);
                        setCookie('userChooseInfo', 0, monthTimeout);
                        setCookie('SBPPAY', 'TRUE');
                        // close popup
                        window.closePopupInterval = setTimeout(() => {
                            if ($('#bank_iframe').length > 0) {
                                window.postMessage('ticketTimeout', '*');
                            }
                        }, window.expire_date - Date.now());

                        this.setState({
                            loading: false,
                        });
                    }
                } else if (json.data.available || json.errors) {
                    const err = json.errors;
                    returnError([err]);
                }
            })
            .catch(() => {
                this.setState({
                    loading: false,
                });
            });
    }

    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return "Android";
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "PC";
    }

    getQrView(userAgent) {
        if (this.state.sbpResponse !== null) {
            if (userAgent === 'PC') {
                return <QrPCView qr={this.state.sbpResponse.qrImage} orderNumber={this.state.sbpResponse.order_number} redirectLink={this.state.sbpResponse.callback_url} />
            } else {
                return <QrMobileView payInfo={this.state.sbpResponse} os={userAgent} orderNumber={this.state.sbpResponse.order_number} redirectLink={this.state.sbpResponse.callback_url} />
            }
        } else {
            return <></>;
        }
    }

    render() {
        const { selected, checkout, amount } = this.props;
        const choosedTicketClasses = ['hint__tickets'];
        if (selected.length) choosedTicketClasses.push('hint__tickets--active');

        const choosedTicketText = selected.length
            ? `${selected.length} ${decl(selected.length, [
                'билет',
                'билета',
                'билетов',
            ])} за ${amount - checkout.bonusPay} руб.`
            : `Выберите места`;

        const sbpPayView = this.getQrView(this.getMobileOperatingSystem());

        return (
            <div className="buy-checkout-side__container">
                {/* mobile version */}
                <div className="scheme-popup__top">
                    <button
                        className="scheme-popup__top-btn left"
                        type="button"
                        onClick={() => this.props.onBackClick()}
                    >
                        <svg
                            className="icon--shev"
                            width="10"
                            height="15"
                            viewBox="0 0 5 8"
                        >
                            <path d="M3.6 7.8c.2.1.4.2.6.2.4 0 .8-.4.8-.9 0-.2-.1-.4-.3-.6l-2.6-2.5 2.6-2.5c.2-.2.3-.4.3-.6 0-.5-.4-.9-.8-.9-.2 0-.4.1-.6.2l-3.3 3.1c-.3.3-.4.9 0 1.2l3.3 3.3z" />
                        </svg>
                    </button>
                    <h4 className="heading heading--2">Оформление заказа</h4>
                </div>

                {/* desktop version */}
                <button
                    onClick={() => this.props.onBackClick()}
                    className="buy-checkout-side__back"
                >
                    <svg width="8" height="5">
                        <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-shev-down"></use>
                    </svg>
                    Назад
                </button>

                <h4 className="heading heading--2">Оплата СБП</h4>
                {sbpPayView}
                <div className="checkout-result__wrapper">
                    <button
                        className={choosedTicketClasses.join(' ')}
                        onClick={() => this.props.showTooltip()}
                    >
                        {choosedTicketText}
                    </button>
                </div>
                <Regulations link={this.props.user.pd} />
            </div>
        );
    }
}